<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-head"><a id="page_4"></a><b><i>Dedication</i></b></p>
<p class="ded"><b>For my Frank</b></p>
<p class="ded"><b>My husband, friend, and partner in life</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?48e5dd36